import { lazyWithRetry as lazy } from '@utils/lazyWithRetry';
import {
  contractorDashboardDetailRoutes,
  contractorMonthlyReportRoutes,
} from '@component/LightVersion/Reports/rideshare-reports/helpers';
import { memberHideDashboardRoutes } from '@component/LightVersion/Reports/member-reports/helpers';
import { rideHideDashboardRoutes } from '@component/LightVersion/Reports/ride-reports/constants';
import { RouteConfig } from '@routes/types';

const PageWrapper = lazy(() => import('@page/PageWrapper'));
const PageNotFound = lazy(() => import('@component/PageNotFound/PageNotFound'));
const IconsWrapper = lazy(() => import('@page/IconsWrapper'));
const ConfigWrapper = lazy(() => import('@page/ConfigWrapper'));
const SomethingWentWrong = lazy(
  () => import('@component/SomethingWentWrong/SomethingWentWrong')
);
const NoAuthorization = lazy(
  () => import('@component/NoAuthorization/NoAuthorization')
);

const Monitoring = lazy(() => import('@component/Monitoring/Monitoring'));

const ProfileAuditLogs = lazy(
  () => import('@component/Profile/ProfileAuditLogs')
);
const ProfilePermissions = lazy(
  () => import('@component/Profile/ProfilePermissions/ProfilePermissions')
);
const ProfileRecentActivity = lazy(
  () => import('@component/Profile/ProfileRecentActivity/ProfileRecentActivity')
);
const ProfileUserProfile = lazy(
  () => import('@component/Profile/ProfileUserProfile')
);

const MemberReports = lazy(
  () => import('@component/LightVersion/Reports/member-reports/MemberReports')
);
const RideshareReports = lazy(
  () =>
    import(
      '@component/LightVersion/Reports/rideshare-reports/RideshareReportsDashboard'
    )
);
const RideReports = lazy(
  () => import('@component/LightVersion/Reports/ride-reports/RideReports')
);
const ContractorRejectedReports = lazy(
  () => import('@src/components/LightVersion/Reports/ContractorRejectedReports')
);
const RideTables = lazy(
  () => import('@src/components/LightVersion/Reports/ride-reports/ride-tables')
);
const RideshareTables = lazy(
  () =>
    import(
      '@src/components/LightVersion/Reports/rideshare-reports/rideshare-tables'
    )
);
const RideshareSeeRidesTable = lazy(
  () =>
    import(
      '@src/components/LightVersion/Reports/rideshare-reports/rideshare-see-rides-table'
    )
);
const ContractorMonthlyReportTable = lazy(
  () =>
    import(
      '@src/components/LightVersion/Reports/rideshare-reports/ContractorMonthlyReportTable'
    )
);
const MemberTables = lazy(
  () => import('@component/LightVersion/Reports/member-reports/member-tables')
);

export const rideshareMonitoringRoute: RouteConfig = {
  path: 'monitoring',
  element: PageWrapper,
  children: [{ path: '', element: Monitoring }],
};

export const rideshareProfileRoute: RouteConfig = {
  path: 'profile',
  element: PageWrapper,
  children: [
    { path: 'user-profile', element: ProfileUserProfile },
    { path: 'audit-logs', element: ProfileAuditLogs },
    { path: 'permissions', element: ProfilePermissions },
    { path: 'recent-activity', element: ProfileRecentActivity },
    { path: '*', element: PageNotFound },
  ],
};

export const rideshareReportingRoute: RouteConfig = {
  path: 'reporting',
  element: PageWrapper,
  children: [
    {
      path: 'ride-reports',
      element: RideReports,
      children: rideHideDashboardRoutes.map((path) => ({
        path,
        element: RideTables,
      })),
    },
    {
      path: 'member-reports',
      element: MemberReports,
      children: memberHideDashboardRoutes.map((path) => ({
        path,
        element: MemberTables,
      })),
    },
    {
      path: 'rideshare-reports',
      element: RideshareReports,
      children: [
        ...contractorDashboardDetailRoutes.map((path) => ({
          path,
          element: RideshareTables,
        })),
        ...contractorDashboardDetailRoutes.map((path) => ({
          path: `${path}/see-rides`,
          element: RideshareSeeRidesTable,
        })),
        ...contractorMonthlyReportRoutes.map((path) => ({
          path,
          element: ContractorMonthlyReportTable,
        })),
        ...contractorMonthlyReportRoutes.map((path) => ({
          path: `${path}/see-rides`,
          element: RideshareSeeRidesTable,
        })),
      ],
    },
    {
      path: 'contractor-rejected-reports',
      element: ContractorRejectedReports,
    },
  ],
};

export const rideshareUtilityRoutes: RouteConfig[] = [
  { path: 'icons', element: IconsWrapper },
  { path: 'configs', element: ConfigWrapper },
  { path: 'wrong', element: SomethingWentWrong },
  { path: 'no-authorization', element: NoAuthorization },
  { path: '*', element: PageNotFound },
];
